import { SetStateAction, useSetAtom, WritableAtom } from 'jotai';
import { CustomField } from 'src/admin/customFields/entities/customFields.entity';
import { Chip } from '../../Chips/Chip';
import { findCustomFieldDefinitionById } from 'src/admin/customFields/utils/customFieldHelpers';

type DropdownCustomFieldChipsProps = {
  isLoading: boolean;
  customFieldDefinitions: CustomField[];
  customFieldDefinitionId: string;
  customFieldValue: string;
  customFieldsAtom: WritableAtom<
    Record<string, string | string[]>,
    [SetStateAction<Record<string, string | string[]>>],
    void
  >;
};

export const TextCustomFieldChip = ({
  customFieldDefinitions,
  customFieldDefinitionId,
  customFieldValue,
  customFieldsAtom,
  isLoading,
}: DropdownCustomFieldChipsProps) => {
  const setCustomFields = useSetAtom(customFieldsAtom);
  const customFieldDefinition = findCustomFieldDefinitionById(
    customFieldDefinitions,
    customFieldDefinitionId,
  );

  if (!customFieldDefinition) {
    return null;
  }

  const customFieldName = customFieldDefinition.label;

  return (
    <Chip
      label={`${customFieldName}: ${customFieldValue}`}
      key={`${customFieldName}: ${customFieldValue}`}
      size="medium"
      variant="filled"
      isLoading={isLoading}
      onDelete={() => {
        setCustomFields((customFields) => ({
          ...customFields,
          [customFieldDefinitionId]: '',
        }));
      }}
    />
  );
};
